export const ADD_TT_COLUMN = 'ADD_TT_COLUMN';
export const ADD_TRANSLATION_TABLE = 'ADD_TRANSLATION_TABLE';
export const ADD_TT_ROW = 'ADD_TT_ROW';
export const UPDATE_INPUT_FIELD_DATA = 'UPDATE_INPUT_FIELD_DATA';
export const UPDATE_SOURCE_COLUMN = 'UPDATE_SOURCE_COLUMN';
export const UPDATE_TARGET_COLUMN = 'UPDATE_TARGET_COLUMN';
export const UPDATE_TRANSLATION_TABLE = 'UPDATE_TRANSLATION_TABLE';
export const SAVE_TRANSLATION_TABLE = 'SAVE_TRANSLATION_TABLE';
export const SAVING_TRANSLATION_TABLE = 'SAVING_TRANSLATION_TABLE';
export const CHANGING_COL_LIST = 'CHANGING_COL_LIST';
export const CHANGING_COL_LIST_SUCCESS = 'CHANGING_COL_LIST_SUCCESS';
export const ADD_TT_COL_LIST_ITEM = 'ADD_TT_COL_LIST_ITEM';
export const UPDATE_TT_COL_LIST_ITEM = 'UPDATE_TT_COL_LIST_ITEM';
export const DELETE_TT_COL_LIST_ITEM = 'DELETE_TT_COL_LIST_ITEM';
export const FETCH_TT_COL_LIST_ITEMS = 'FETCH_TT_COL_LIST_ITEMS';
export const SAVE_MATCH_COL_LIST_SUCCESS = 'SAVE_MATCH_COL_LIST_SUCCESS';
export const ADD_TRANSLATION_TABLE_TO_PROFILE = 'ADD_TRANSLATION_TABLE_TO_PROFILE';
export const FETCH_TT_DATA = 'FETCH_TT_DATA';
export const FETCHING_TT_DATA = 'FETCHING_TT_DATA';
export const DELETE_TRANSLATION_TABLE_SUCCESS = 'DELETE_TRANSLATION_TABLE_SUCCESS';
export const RESET_TRANSLATION_TABLE = 'RESET_TRANSLATION_TABLE';
export const FETCHING_ALL_TRANSLATION_TABLES = 'FETCHING_ALL_TRANSLATION_TABLES';
export const FETCH_ALL_TRANSLATION_TABLES_SUCCESS = 'FETCH_ALL_TRANSLATION_TABLES_SUCCESS';
export const CANCEL_MATCH_COL_LIST = 'CANCEL_MATCH_COL_LIST';
export const CLEAR_ROWS = 'CLEAR_ROWS';
export const FETCHING_TRANSLATION_TABLE = 'FETCHING_TRANSLATION_TABLE';
export const SET_TT_EDITION_MODE = 'SET_TT_EDITION_MODE';
export const RESET_TT_EDITION_MODE = 'RESET_TT_EDITION_MODE';
export const FETCH_TRANSLATION_TABLE_SUCCESS = 'FETCH_TRANSLATION_TABLE_SUCCESS';
export const CLEAR_LIST_ITEMS = 'CLEAR_LIST_ITEMS';



// WEBPACK FOOTER //
// ./src/redux/translationTable/TranslationTableConstants.js